import { z } from 'zod'

type GenerateTokenFormValues = {
  keyName: string
  expiresIn: string
  scopeNames: string[]
}

const generateTokenFormSchema: z.ZodType<
  GenerateTokenFormValues,
  GenerateTokenFormValues
> = z.object({
  keyName: z.string(),
  expiresIn: z.string(),
  scopeNames: z
    .array(z.string())
    .min(1, 'Select at least one permission for this key.'),
})

export { generateTokenFormSchema }
export type { GenerateTokenFormValues }
